/*
 * @Author: cjw 
 * @Date: 2021-03-30 17:25:54 
 * @Last Modified by: cjw
 * @Last Modified time: 2021-11-12 18:02:30
 */

/*
 * 提供过滤数据功能
 *
 * 提供以下接口
 * 1. filter(el => el.xxx === xxx)  过滤数据接口
 * 2. datas                         经过滤后的数组
*/

// 是否为数组的下标（索引）
// function isArrayIndex(obj) {
//     return /^\d+$/.test(obj)
// }

function getProxy(target, meta) {
    // 如果对象已有代理，则返回代理
    let observed = meta.toProxy.get(target)
    if (observed !== void 0) {
        return observed
    }

    if (meta.toRaw.get(target)) {
        return target
    }
}

// 设置过滤接口
function createFilter(meta) {
    return function filter(callback) {
        meta.filter = callback
    }
}

// 实现对过滤数组的增、删除转向调用原数组的增、删除
function createReactiveDataTable(target, meta) {

    // 如果对象已有代理，则返回代理
    const proxyObject = getProxy(target, meta)
    if (proxyObject) {
        return proxyObject
    }

    const createGetter = function(meta) {
        return function get(target, property /*, receiver */) {
            // 不能传递 receiver 参数，如果传入 DataTable 的 datas 用 vue 的 reactive 封装后会出现死循环，不用 reactive 则界面不刷新
            const res = Reflect.get(target, property /*, receiver */)
            if (typeof res === 'function') {
                // console.log('调用方法', property)
                switch (property) {
                    case 'push':
                        return function() {
                            // console.log(`调用 ${property} 方法`, arguments)
                            meta.target.datas.push(...arguments)
                            return res.apply(target, arguments)
                        }
                    case 'unshift':
                        return function() {
                            // console.log(`调用 ${property} 方法`, arguments)
                            meta.target.datas.unshift(...arguments)
                            return res.apply(target, arguments)
                        }
                    case 'splice':
                        return function() {
                            // console.log(`调用 ${property} 方法`, arguments)
                            const delArrs = res.apply(target, arguments)
                            delArrs?.forEach(obj => {
                                const index = meta.target.datas.findIndex(el => el === obj)
                                meta.target.datas.splice(index, 1)
                            })

                            return delArrs
                        }
                    case 'pop':
                    case 'shift':
                        return function() {
                            // console.log(`调用 ${property} 方法`, arguments)
                            const delObj = res.apply(target, arguments)
                            const index = meta.target.datas.findIndex(el => el === delObj)
                            meta.target.datas.splice(index, 1)
                            return delObj
                        }
                    default:
                        break;
                }
            }

            // 如果是对象，递归代理
            return res
        }
    }

    // 由于之前不知道如何捕获 push、splice、unshift、shift、pop 等方法，所以通过判断长度、索引等变化记录日志，现已通过 get 代理解决
    // const createSetter = function(meta) {
    //     return function set(target, property, value, receiver) {

    //         if (isArrayIndex(property)) {
    //             if ((target.length - 1) < property) {
    //                 // 数组新增时转向对原对象进行新增
    //                 meta.target.datas.push(value)

    //                 // 需要重新获取刚新增的对象，因为设置后原对象可能是个代理，会将对象转为代理
    //                 value = meta.target.datas[meta.target.datas.length - 1]
    //             } else {
    //                 // 缓存疑似被删除的记录
    //                 if (!meta.caches.deletes) {
    //                     meta.caches.deletes = []
    //                 }
    //                 meta.caches.deletes.push(target[property])
    //             }
    //         }

    //         switch (property) {
    //             case 'length':
    //                 if (meta.caches.deletes && target.length > value) {
    //                     // 数据源长度减去本次设置length长度，可以得到删除的个数，然后从缓存中取出相应个数得到删除的元素
    //                     // 在 createSetter 及 createDeleteProperty 会将疑似删除的元素存进缓存中
    //                     const rows = meta.caches.deletes.slice(0, target.length - value)
    //                     rows.forEach(row => {
    //                         const index = meta.target.datas.findIndex(el => el === row)
    //                         if (index !== -1) {
    //                             // 数组删除时转向对原对象进行删除
    //                             meta.target.datas.splice(index, 1)
    //                         }
    //                     })
    
    //                     delete meta.caches.deletes
    //                 }
    //                 break;
    //             default:
    //                 break;
    //         }
    
    //         // 设置属性值
    //         return Reflect.set(target, property, value, receiver)
    //     }
    // }

    // const createDeleteProperty = function(meta) {
    //     return function deleteProperty(target, property) {
    //         if (isArrayIndex(property)) {
    //             // 缓存疑似被删除的记录
    //             if (!meta.caches.deletes) {
    //                 meta.caches.deletes = []
    //             }
    //             meta.caches.deletes.push(target[property])
    //         }
    //         return true
    //     }
    // }

    const handlers = {
        get: createGetter(meta),
        // set: createSetter(meta),
        // deleteProperty: createDeleteProperty(meta)
    }

    // 创建 Proxy 代理
    const observed = new Proxy(target, handlers)
    meta.toProxy.set(target, observed)
    meta.toRaw.set(observed, target)
    return observed
}

// 创建响应式对象
function createReactiveDataSource(target, meta) {

    const createGetter = function(meta) {
        return function get(target, property, receiver) {
            switch (property) {
                case 'filter':
                    // 获取当前行对象
                    return createFilter(meta)
                case 'datas':
                    meta.datas.length = 0
                    meta.datas.push(...target.datas.filter(el => !meta.filter || meta.filter(el)))
                    // 不直接代理原对象的 datas 属性，而是用另外一个过滤好的数组进行代理，以实现数组的增加和删除
                    return createReactiveDataTable(meta.datas, meta)
                default:
                    break;
            }
            
            return Reflect.get(target, property, receiver)
        }
    }

    const handlers = {
        get: createGetter(meta)
    }

    // 创建 Proxy 代理
    return new Proxy(target, handlers)
}

export function ProxyFilter(target, options) {
    const meta = {
        options: options,
        // 保存一份目标对象，用于在增删数据时转为对目标进行增删
        target: target,
        // 过滤后的数组
        datas: [],
        // 已代理的 DataRow 集合（key:原始对象，value:代理对象），用于解决重复代理
        toProxy: new WeakMap(),
        // 已代理的 DataRow 集合（key:代理对象，value:原始对象），与 toProxy 相反
        toRaw: new WeakMap(),
        // 过滤方法
        filter: null,
        // // 缓存（用于记录临时数据）
        // caches: {
        //     // 由于删除时涉及多个方法，所以需要缓存临时存储被删除的元素
        //     deletes: []
        // }
    }

    return createReactiveDataSource(target, meta)
}